<script lang="ts" setup>
  import { computed } from 'vue'
  import Island from 'vue-material-design-icons/Island.vue'
  import HomeCircleOutline from 'vue-material-design-icons/HomeCircleOutline.vue'
  import HomeOutline from 'vue-material-design-icons/HomeOutline.vue'
  import CarArrowRight from 'vue-material-design-icons/CarArrowRight.vue'
  import HospitalBox from 'vue-material-design-icons/HospitalBox.vue'
  import HelpCircleOutline from 'vue-material-design-icons/HelpCircleOutline.vue'

  export interface Props {
    code: string | null | undefined
    size?: number
  }

  const props = withDefaults(defineProps<Props>(), {
    size: 40
  })

  const componentMap = {
    A: HomeCircleOutline,
    O: CarArrowRight,
    H: HomeOutline,
    I: HospitalBox,
    X: HelpCircleOutline,
    V: Island
  } as const
  const colorMap: Record<string, string | undefined> = {
    A: '#a3d179',
    H: '#a3d179',
    O: '#efc849',
    V: '#efc849',
    I: '#ff0618'
  }

  const currentColor = computed(() => (props.code ? colorMap[props.code] : undefined))

  const currentComponent = computed(() => (props.code ? (componentMap[props.code] ?? null) : null))
</script>

<template>
  <component
    :is="currentComponent"
    :size="size"
    :style="{ color: currentColor }"
    v-bind="$attrs" />
</template>
